import { render, staticRenderFns } from "./PromotionFormBulk.vue?vue&type=template&id=a76055a8&"
import script from "./PromotionFormBulk.vue?vue&type=script&lang=js&"
export * from "./PromotionFormBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports